import React, { useContext } from 'react'
import classNames from 'classnames'
import { func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { productDataType } from 'models/propTypes'
import ProductItemDetail from 'components/designSidepanel/ProductItemDetail'
import ProductItemImage from 'components/designSidepanel/ProductItemImage'
import Icon from 'components/uiElements/Icon'
import FavoriteButtonContainer from 'containers/uiElements/FavoriteButtonContainer'
import { TRACK_LOCATION_SIDEPANEL } from 'models/tracking/constants'
import SugarcubeContext from 'apps/SugarcubeContext'

require('./ProductItem.scss')

const ProductItemWide = ({ productData, onSelect, viewDetails, addToBag, addToRoom }) => {
    const { t } = useTranslation()
    const { isMobile, isKiosk } = useContext(SugarcubeContext)
    const { name, price, description, thumbUrl, localItemNumber } = productData
    const viewDetailsClick = () => {
        onSelect()
        viewDetails()
    }

    const isInDesignSummaryView = !viewDetails
    return (
        <div className={classNames('ProductItem ProductItemWide', { isMobile })}>
            <div className={classNames('itemImageContainer', { isStaticImage: isInDesignSummaryView })}>
                <ProductItemImage thumbUrl={thumbUrl} name={name} />
            </div>

            <div className="itemDetailContainer">
                <ProductItemDetail
                    name={name}
                    price={price}
                    description={description}
                    wide
                    viewDetails={isInDesignSummaryView ? null : viewDetailsClick}
                />
                <div className="productCTAs">
                    {addToRoom && (
                        <button className="primaryCTA" onClick={addToRoom}>
                            <Icon code="plus" svg />
                            <span>{t('design.add to room')}</span>
                        </button>
                    )}
                    {!addToRoom && !isKiosk && (
                        <button className="primaryCTA" onClick={addToBag}>
                            <Icon code="shopping_bag_add" svg />
                            <span>{t('design.add to bag')}</span>
                        </button>
                    )}
                    <div className="secondaryCTAs">
                        {addToRoom && !isKiosk && (
                            <button onClick={addToBag} aria-label={t('design.add to bag')}>
                                <Icon code="shopping_bag_add" svg />
                            </button>
                        )}
                        <FavoriteButtonContainer
                            localItemNumber={localItemNumber}
                            location={TRACK_LOCATION_SIDEPANEL}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

ProductItemWide.defaultProps = {
    addToRoom: null,
    viewDetails: null,
}

ProductItemWide.propTypes = {
    productData: productDataType.isRequired,
    onSelect: func.isRequired,
    viewDetails: func,
    addToBag: func.isRequired,
    addToRoom: func,
}

export default ProductItemWide
